import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from "../TwoCardTeenPati/styles.module.css";
import FooterLinks from "../FooterLinks";
import { useLocation } from "react-router-dom";
import GameScreen from "./GameScreen";
import FlipClock from "../../FlipClock/FlipClock";
import useCasinoBetplace from "../../../api/useCasinoBetplace";

import RoundLoader from "../../Loader/RoundLoader";

function TeenPatiTtweenty({ onBetSelect, locked, socketData, settledData ,hookExposureData,gameId}) {
  const [betDialogOpen, setBetDialogOpen] = useState(false);
  const [selectedBet, setSelectedBet] = useState(null);

  const location = useLocation();

  const roundId = socketData?.roundId;

  const [exposureData, setExposureData] = useState(null);
  const [animTimer, setAnimTimer] = useState(null);
 
  const isBettingLocked = locked || socketData?.bettingClosed === true;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

 useEffect(() => {
    if (hookExposureData === null) {
        setExposureData(null);
        return;
    }
    if (hookExposureData && hookExposureData.gameId === gameId) {
        setExposureData(hookExposureData);
    }
}, [hookExposureData, gameId]);


  const handleNumberBoxClick = (
    value,
    label,
    positionIndex,
    isLock = false,
  ) => {
    if (isBettingLocked || isLock) return;

    const selection = positionIndex === 0 ? "PLAYER_A" : "PLAYER_B";
    const betType = isLock ? "LAY" : "BACK";

    const betData = {
      label: `${label}`,
      odds: parseFloat(value),
      position: "",
      betType,
      selection,
    };

    setSelectedBet(betData);
    setBetDialogOpen(true);

    if (onBetSelect) onBetSelect(betData);
  };

  const getExposure = (player) => {
    if (!exposureData) return null;

    let val;
    if (player === "A") {
      val = exposureData.playerA ?? exposureData.playerAWins;
    } else {
      val = exposureData.playerB ?? exposureData.playerBWins;
    }

    if (val === undefined || val === 0 || val === 0.0) return null;
    return Number(val);
  };
  const ExposureLabel = ({ value }) => {
    if (value === null || value === undefined) return null;

    return (
      <Typography
        sx={{
          fontSize: "12px",
          fontWeight: 700,
          color: value >= 0 ? "#46a54b" : "#ff4444",
          textAlign: "left",

          padding: "2px 0",
          minHeight: "20px",
        }}
      >
        {value > 0 ? `${value.toFixed(2)}` : value.toFixed(2)}
      </Typography>
    );
  };

  const mainRows = [
    { label: "Player A", key: "A", values: ["1.98"] },
    { label: "Player B", key: "B", values: ["1.98"] },
  ];

  return (

      <Box className={styles.MatchScreen_container}>
        <Box sx={{ position: "relative", width: "100%" }}>
          <GameScreen
            bettingClosed={socketData?.bettingClosed === true}
            animationTime={
              typeof socketData?.animationTime === "number"
                ? socketData.animationTime
                : undefined
            }
            socketData={socketData}
            settledData={settledData}
            onAnimStart={() => setAnimTimer(0)}
            onAnimEnd={() => setAnimTimer(null)}
          />

          <Box>
            <Box>
            {(animTimer !== null || socketData?.remainingTime > 0) && (
    <Box sx={{ position: "absolute", bottom: "8px", right: "8px", zIndex: 99, pointerEvents: "none" }}>
      <FlipClock time={animTimer !== null ? animTimer : (socketData?.remainingTime)} />
    </Box>
)}
            </Box>
          </Box>
        </Box>

        {/* Players Section */}
        <Box className={styles.box1}>
          {mainRows.map((row, rowIdx) => (
            <Box key={row.label} className={styles.PlayerCardBox}>
              <Box className={styles.PlayerCardBoxInner}>
                <Typography className={styles.PlayerCardText}>
                  {row.label}
                  <ExposureLabel value={getExposure(row.key)} />
                </Typography>
              </Box>

              {/* BACK Box */}
              {row.values.map((val, i) => (
                <Box
                  key={`val-${i}`}
                  className={styles.BlueBox}
                  onClick={() =>
                    handleNumberBoxClick(val, row.label, rowIdx, false)
                  }
                  sx={{
                    cursor: isBettingLocked ? "not-allowed" : "pointer",
                    position: "relative",
                  }}
                >
                  <Typography className={styles.BlueBoxText}>{val}</Typography>

                  {/* FIX: Lock Icon - ab bettingClosed/locked hone par yaha bhi dikhega */}
                  {isBettingLocked && (
                    <Box
                      className={styles.bettinglocked_icon_container}
                      sx={{ pointerEvents: "none" }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#fff"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <rect
                          x="5"
                          y="11"
                          width="14"
                          height="10"
                          rx="2"
                          ry="2"
                        />
                        <path d="M12 5a4 4 0 0 1 4 4v2H8V9a4 4 0 0 1 4-4z" />
                      </svg>
                    </Box>
                  )}
                </Box>
              ))}

              {/* LOCK Box */}
              <Box
                className={styles.BlueBox}
                sx={{
                  cursor: "not-allowed",
                  position: "relative",
                  backgroundColor: "#1a1a1a",
                }}
              >
                <Typography className={styles.BlueBoxText}>14.33</Typography>

                {/* Lock Icon */}
                <Box
                  className={styles.bettinglocked_icon_container}
                  sx={{ pointerEvents: "none" }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#fff"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="5" y="11" width="14" height="10" rx="2" ry="2" />
                    <path d="M12 5a4 4 0 0 1 4 4v2H8V9a4 4 0 0 1 4-4z" />
                  </svg>
                </Box>
              </Box>
            </Box>
          ))}
        </Box>

        <FooterLinks
          socketData={socketData}
          settledData={settledData}
          gameType="TeenPatiTtweenty"
        />
      </Box>

  );
}

export default TeenPatiTtweenty;
